import { AppFile, AppFileDataExt } from 'globales-projekt-angular';
import { DateiTyp } from 'src/app/immutable/enums/datei-typ';
import { ApiService } from 'src/app/services/api.service';

export class FileAppMetaDatas {
  verordnung: AppFileDataExt = new AppFileDataExt();
  betriebsgroessenklassen: AppFileDataExt = new AppFileDataExt();
  nuts_zwei_regionen: AppFileDataExt = new AppFileDataExt();

  constructor(private apiService: ApiService) {}

  loadFileAppMetaDatas() {
    this.apiService.getAppFileSizeDocuments().subscribe((response) => {
      let appFileList: AppFile[] = response;

      for (let entry of appFileList) {
        let appFileDataExt: AppFileDataExt = new AppFileDataExt(entry);

        if (appFileDataExt.idTyp == DateiTyp.VERORDNUNG) {
          this.verordnung = appFileDataExt;
        } else if (
          appFileDataExt.idTyp == DateiTyp.BETRIEBSGROESSENKLASSEN
        ) {
          this.betriebsgroessenklassen = appFileDataExt;
        } else if (appFileDataExt.idTyp == DateiTyp.NUTS_ZWEI_REGIONEN) {
          this.nuts_zwei_regionen = appFileDataExt;
        }
      }
    });
  }
}
